﻿/**
 * The DrawingService implements the interface used by the Component/Product classes to update the
 * product drawing. At the time of this writing the abstract methods that are used have not yet been
 * added to this abstract base class.
 */
export class DrawingService {
  constructor(getProductFinishName) {
    this.getProductFinishName = getProductFinishName;
    this.materialPrefixDelim = '-';
  }
}
